import selectors from './selectors'
import slice from './slice'
import thunks from './thunks'

export { slice as examsSlice, selectors as examsSelectors, thunks as examsThunks }
